import { Box, BoxProps } from '@primer/react';
import React from 'react';
import { Helmet } from 'react-helmet';
import { useWindowSize } from '../../../hooks/useWindowSize';
interface IPageProps extends BoxProps {
    title?: string
}
const Page = (props: IPageProps) => {
    const { height } = useWindowSize();
    return (
        <>
            <Helmet>
                <title>{props.title}</title>
            </Helmet>
            <Box sx={{
                pt: 3,
                pr: 2,
                pl: 2,
                backgroundColor: "#fff",
                minHeight: height - 120,
                height: height - 200,
                overflowY: "auto",
                borderRadius: 2,
                ...props.sx
            }}>
                {props.children}
            </Box>
        </>
    );
};

export default Page;